import { Navigate, Outlet } from "react-router";

import { FullScreenLoader } from "@punto/ui/components/full-screen-loader";

import { useUser } from "@/modules/auth/hooks/use-user";

import { useBaseRoute } from "./use-base-route";

/**
 * Route guard restricting nested routes to Punto developers (e.g. Commander).
 * Hiding the nav entry is cosmetic; this blocks direct navigation too. The API
 * is the real enforcement (see janus-api `commander/developer-access.ts`).
 */
const DeveloperRoute = () => {
  const { user } = useUser();
  const baseRoute = useBaseRoute();

  if (!user) {
    return <FullScreenLoader />;
  }

  if (!user.isDeveloper) {
    return <Navigate to={baseRoute} replace />;
  }

  return <Outlet />;
};

export { DeveloperRoute };
